import React, { useEffect, useState } from 'react';
import cidadesEstadosService from '../../../../services/cidades-estados/cidades-estados-service';
import { Field, useFormikContext } from 'formik';
import { Dropdown } from 'primereact/dropdown';

export default function Cidades() {
    const { values } = useFormikContext();
    const { estado } = values;
    const [cidades,setCidades] = useState([]);
    const [loading,setLoading] = useState(false);
    const [erroChamadaBackend,setErroChamadaBackend] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                if(estado){
                    setLoading(true);

                    const cidades = (
                        await cidadesEstadosService.getCidadesEstado(estado)
                    ).map(({ nome,id }) => ({
                        label: nome,
                        value: id
                    }));

                    setCidades(cidades);
                }
            } catch (error) {
                setErroChamadaBackend(true);
            }
            finally{
                setLoading(false);
            }
        })();
    }, [values]);
    
    const feedbackMsg = () => {
        if (erroChamadaBackend){
            return 'Não foi possível carregar as cidades, tente novamente ';
        }

        if (loading){
            return 'Carregando';
        }

        return 'Selecione uma cidade';
    };

    return (
        <div className="p-col-12 p-md-12 p-lg-6 p-field">
            <div className="form-item-label">
                <label htmlFor="cidade">Cidade</label>                    
                <Field
                    as={Dropdown}
                    id="cidade"
                    disabled={erroChamadaBackend || loading || cidades.length === 0}
                    placeholder = {feedbackMsg()}
                    filter={true} filterPlaceholder="Procurar" filterBy="label,value"
                    name="cidade"
                    options={cidades}
                    scrollHeight="150px"
                />                            
            </div>
        </div>
    );
}
